export default __webpack_public_path__ + "static/media/CIHE_Composicion_sola4.9d378437.jpg";